const WITHDRAWAL = `${process.env.API_V4_HOST}/withdrawals`;

/**
 * @param {object} payload
 * @param {number} payload.transactionId
 * @returns {Promise}
 */
// https://blueprint.bukalapak.io/t/wallet~topups~and~withdrawals~withdrawals~get~withdrawals~id
export const getDepositWithdrawal = ($axios, transactionId) => $axios.$get(`${WITHDRAWAL}/${transactionId}`);
